import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import AgentPage from "@/pages/AgentPage";

export const Route = createFileRoute("/by/agent")({
  head: () => routeHead('AI-агент AGAPE — Паспрабуйце асістэнта', META_DESCRIPTIONS.agent.by, '/by/agent'),
  component: AgentPage,
});
